import type { NextPage } from 'next'

import Promo from '@/components/blocks/Promo/Promo'
import Layout from '@/components/layouts/Layout'
import { getStaticPropsTranslations } from '@/utils/i18n'

const PromoCodePage: NextPage = () => {
  return (
    <Layout hasNoFollow hasNoIndex>
      <Promo />
    </Layout>
  )
}

export default PromoCodePage

export function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking',
  }
}

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await getStaticPropsTranslations(locale)),
    },
  }
}
